import React from 'react';

const FaCircleCalcIcon = ({
  backgroundColor = process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#171b54' : '#3DA4BC',
  color = '#fff',
  size = 30,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 19 19">
    <g id="Grupo_1755" data-name="Grupo 1755" transform="translate(-972 -17)">
      <g id="Elipse_8" data-name="Elipse 8" transform="translate(972 17)" fill={color} stroke={color} strokeWidth="1">
        <circle cx="9.5" cy="9.5" r="9.5" stroke="none" />
        <circle cx="9.5" cy="9.5" r="9" fill="none" />
      </g>
      <path
        id="Icon_awesome-calculator"
        data-name="Icon awesome-calculator"
        d="M9.86,0H1.183A1.214,1.214,0,0,0,0,1.185V11.459a1.214,1.214,0,0,0,1.183,1.185H9.86a1.214,1.214,0,0,0,1.183-1.185V1.185A1.214,1.214,0,0,0,9.86,0Zm-6.7,10.748a.34.34,0,0,1-.316.316H1.893a.34.34,0,0,1-.316-.316V9.8a.34.34,0,0,1,.316-.316H2.84a.34.34,0,0,1,.316.316Zm0-3.161A.34.34,0,0,1,2.84,7.9H1.893a.34.34,0,0,1-.316-.316V6.638a.34.34,0,0,1,.316-.316H2.84a.34.34,0,0,1,.316.316ZM6.31,10.748a.34.34,0,0,1-.316.316H5.048a.34.34,0,0,1-.316-.316V9.8a.34.34,0,0,1,.316-.316h.947A.34.34,0,0,1,6.31,9.8Zm0-3.161a.34.34,0,0,1-.316.316H5.048a.34.34,0,0,1-.316-.316V6.638a.34.34,0,0,1,.316-.316h.947a.34.34,0,0,1,.316.316Zm3.155,3.161a.34.34,0,0,1-.316.316H8.2a.34.34,0,0,1-.316-.316V6.638A.34.34,0,0,1,8.2,6.322H9.15a.34.34,0,0,1,.316.316v4.11Zm0-6.322a.34.34,0,0,1-.316.316H1.893a.34.34,0,0,1-.316-.316V1.9a.34.34,0,0,1,.316-.316H9.15a.34.34,0,0,1,.316.316Z"
        transform="translate(975.957 20.565)"
        fill={backgroundColor}
      />
    </g>
  </svg>
);

export default FaCircleCalcIcon;
